// stripAnsi.js — limpa terminal output pra exibição na UI.
//
// O run_command devolve stdout/stderr cru que costuma vir com SGR color codes
// (ESC[90m), cursor moves (ESC[?25l), erase-line (ESC[2K) e progress bars que
// se redesenham via carriage-return (\r). Renderizado as-is, isso vira lixo
// literal "[90m[39m" nas paredes de tool do Code tab. Esta função limpa SÓ pra
// display — a string crua continua alimentando o modelo intacta.

// CSI escape sequences: ESC [ <params> <intermediates> <final>.
// Cobre SGR (cor), cursor show/hide, erase, cursor moves — tudo que aparece em
// saída de npm/npx/git. Montado via fromCharCode pra não embutir o byte ESC
// (0x1B) invisível no source. `[[]` casa um "[" literal (sem backslash).
const ESC = String.fromCharCode(27);
const ANSI_REGEX = new RegExp(`${ESC}[[][0-9;?]*[ -/]*[@-~]`, 'g');

// Colapsa carriage-returns: o terminal sobrescreve a linha atual a cada \r,
// então pra cada linha só sobrevive o texto após o ÚLTIMO \r (estado final
// visível). Normalizamos \r\n → \n antes pra não apagar linhas Windows.
function collapseCarriageReturns(line) {
  if (!line.includes('\r')) return line;
  const parts = line.split('\r');
  return parts[parts.length - 1];
}

export function stripAnsi(input) {
  if (input == null) return '';
  const cleaned = String(input).replace(ANSI_REGEX, '').replace(/\r\n/g, '\n');
  return cleaned.split('\n').map(collapseCarriageReturns).join('\n');
}

export default stripAnsi;
